export default __webpack_public_path__ + "static/button-action-dont-dark-49a7d2d898375bc1db79ab5b02637479b84cb42bbfadb845729bc6b4a33c6749.png";